import { render, staticRenderFns } from "./superadmin-dashboard.vue?vue&type=template&id=515a4cf4&"
import script from "./superadmin-dashboard.vue?vue&type=script&lang=js&"
export * from "./superadmin-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./superadmin-dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports